import { createSelector } from 'reselect'

export const isPaidSessionSelector = createSelector(
  (state: App.State) => state.utm,
  (utm) => utm.bp === '2',
)
